<h1 mat-dialog-title>{{ "Parallel_Send_Back.sendBack" | translate }}</h1>
<mat-dialog-content>
  <h3>{{ "Parallel_Send_Back.Message" | translate }}</h3>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <div class="buttons">
    <button mat-flat-button mat-dialog-close>Close</button>
    <button mat-raised-button class="ms-2" color="primary" (click)="onParallelSendBack()">
      {{ "Parallel_Send_Back.sendBack" | translate }}
    </button>
  </div>
</mat-dialog-actions>
